(() => {
  angular
    .module('app.components')
    .directive('impressionMatrix', ['$sce',
      ($sce) => ({
        restrict: 'E',
        scope: {
          switcher: '=switcher',
          values: '=values',
          viewability: '=viewability',
          campaignId: '=campaignId'
        },
        link: (scope, element) => {
          scope.showViewability = false;

          scope.toggleViwability = () => {
            if (scope.viewability !== undefined) {
              scope.showViewability = !scope.showViewability;
            }
          }

          scope.percentage = (value, total) => total > 0 ? (value * 100 / total).toFixed(1) : 0;
        },
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/impressionMatrix/impressionMatrix.template.html'),
    })
  ]);
})();
